export default __webpack_public_path__ + "static/media/clear-icon-small.155a9619.svg";